import { ReactElement } from 'react';

import styles from './FormLoading.module.scss';

const FormLoading = (): ReactElement => (
  <>
    <div className={styles.loading}>
      <div className="vfH3">Loading your form</div>
      <h4>Please wait</h4>
      <div className={`${styles.cssloadcontainer} ${styles.inline}`}>
        <div className={styles.cssloadwhirlpool} />
      </div>
    </div>
  </>
);

export default FormLoading;
